// Module
var code = "<textarea ng-model=\"formData.description\" class=\"form-control\" name=\"formData.description\"></textarea> <small>{{formData.description.length}} sur 255 caractères</small> <p ng-show=\"isInvalidDescription()\" class=\"text-danger\"> La description ne doit pas dépasser 255 caractères. </p>";
// Exports
export default code;